import { useState, useEffect } from 'react';

const useClientOnly = () => {
  const [isWindow, setIsWindow] = useState(false);
  useEffect(() => {
    setIsWindow(true);
    return () => setIsWindow(false);
  }, []);
  return isWindow;
};

export default useClientOnly;
